module.exports = __webpack_public_path__ + "img/title_uiUx.10f15520.svg";